import { useEffect, useState } from 'react';

import { useRecoilValue } from 'recoil';

import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

import { shouldUseV3Api } from 'src/api/helpers';
import ConfigureProjectDialog from 'src/components/Modal/ConfigureProjectDialog';
import { projectState, useRefreshProject } from 'src/states/project';
import { Modality } from 'src/types/api/data/image';

interface ConfigureProjectButtonProps {
  projectId: string;
  modalityLabel: Modality;
}

const ConfigureProjectButton = ({
  projectId,
  modalityLabel,
}: ConfigureProjectButtonProps): JSX.Element | null => {
  const [open, setOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const refreshProject = useRefreshProject();
  const project = useRecoilValue(
    projectState.project({ projectId, modality: modalityLabel })
  );

  useEffect(() => {
    const check = async () => {
      const v3 = await shouldUseV3Api(projectId, modalityLabel);
      setIsVisible(v3);
    };
    check();
  }, [projectId, modalityLabel]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  if (!isVisible) return null;

  const hasJobs = (project?.jobStats?.total?.total || 0) > 0;
  return (
    <>
      {hasJobs ? (
        <Tooltip
          title="Cannot configure: this project already has jobs."
          placement="top"
        >
          <span style={{ display: 'inline-block' }}>
            <Button
              color="primary"
              variant="contained"
              onClick={handleOpen}
              disabled
              sx={{
                textTransform: 'uppercase',
                fontSize: '12px',
                fontWeight: 500,
                borderRadius: '8px',
                color: '#ffffff',
              }}
            >
              Configure Project
            </Button>
          </span>
        </Tooltip>
      ) : (
        <Button
          color="primary"
          variant="contained"
          onClick={handleOpen}
          sx={{
            textTransform: 'uppercase',
            fontSize: '12px',
            fontWeight: 500,
            borderRadius: '8px',
            color: '#ffffff',
          }}
        >
          Configure Project
        </Button>
      )}
      <ConfigureProjectDialog
        open={open}
        onClose={handleClose}
        projectId={projectId}
        modalityLabel={modalityLabel}
        onUpdated={refreshProject}
        fullWidth
        maxWidth="lg"
      />
    </>
  );
};

export default ConfigureProjectButton;
